import { fromJS } from 'immutable';
import ACTIONS from '../app.constants';
import { InboxList, InboxReducer, InboxReducerActionType, Inbox } from '../modules/inbox/types';

export default function inboxReducer(state = fromJS({}), action: InboxReducerActionType): InboxReducer {
    switch (action.type) {
        case ACTIONS.GET_INBOX_LIST.PENDING: {
            return state.setIn(['inboxList', 'loading'], true);
        }
        case ACTIONS.UPDATE_INBOX_STATUS.PENDING: {
            return state.setIn(['inboxList', 'loading'], true);
        }
        case ACTIONS.GET_INBOX_LIST.SUCCESS: {
            let loadedList = state.getIn(['inboxList', 'data']) ?? [];
            const inboxList: InboxList = action.data as InboxList;
            const loadMore = inboxList.length < action?.paginationData?.limit ? false : true;

            if (loadedList && action.paginationData.skip > 0) {
                loadedList = loadedList.concat(inboxList);
            } else {
                loadedList = inboxList;
            }

            return state
                .setIn(['inboxList', 'data'], loadedList)
                .setIn(['inboxList', 'loadMore'], loadMore)
                .setIn(['inboxList', 'loading'], false);
        }
        case ACTIONS.UPDATE_INBOX_STATUS.SUCCESS: {
            const loadedList = state.getIn(['inboxList', 'data']) ?? [];
            const filterInboxList = loadedList.filter((listItem: Inbox) => listItem.id !== action.payload.id);

            return state.setIn(['inboxList', 'data'], filterInboxList).setIn(['inboxList', 'loading'], false);
        }
        case ACTIONS.SET_INBOX_LIST_COUNT.SUCCESS: {
            return state.setIn(['inboxList', 'inboxCount'], action.inboxCount);
        }
        case ACTIONS.GET_INBOX_LIST.ERROR: {
            return state.setIn(['inboxList', 'loading'], false);
        }
        case ACTIONS.UPDATE_INBOX_STATUS.ERROR: {
            return state.setIn(['inboxList', 'loading'], false);
        }
        case ACTIONS.GET_INBOX_SEARCH_FORM.PENDING: {
            return state.setIn(['inboxSearchForm', 'loading'], true);
        }

        case ACTIONS.CHANGE_INBOX_FILTERS: {
            return state.setIn(['inboxFilters', 'filterSelections'], action.payload.data);
        }

        case ACTIONS.GET_INBOX_SEARCH_FORM.SUCCESS: {
            return state.setIn(['inboxSearchForm', 'loading'], false).setIn(['inboxSearchForm', 'data'], action.data);
        }

        case ACTIONS.GET_INBOX_SEARCH_FORM.ERROR: {
            return state.setIn(['inboxSearchForm', 'loading'], false);
        }
    }

    return state;
}
